// Registriert den Service Worker (public/service-worker.js), damit die
// Seite als PWA installierbar ist. Bewusst simpel gehalten - kein
// Update-Prompt-Schnickschnack, nur die Grundvoraussetzung fürs
// "Zum Startbildschirm hinzufügen".

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((error) => {
        console.error('Service Worker Registrierung fehlgeschlagen:', error);
      });
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
